export enum CategoryTypes {
  trending = 'trending',
  downloads = 'most-downloaded',
  new = 'new',
  openDataSet = 'open-dataset',
  openModel = 'open-model',
  viewAll = 'view-all',
  newest = 'newest',
}

export enum SpotlightCategory {
  article = 'articles',
  news = 'news',
  videos = 'videos',
  viewAll = 'view-all',
}
